<template>
  <div id="login">
    <el-row class="login-info" :style="styles">
      <el-col :span="24" style="margin-bottom:20px;font-size:20px;text-align: center">
        <b>个人信息</b>
      </el-col>
      <el-form label-width="25%" label-position="right">
        <el-form-item label="用户姓名">
          <el-input
            class="login-input"
            placeholder="请输入姓名"
            v-model="username"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号码">
          <el-input
            class="login-input"
            placeholder="请输入手机号"
            disabled
            v-model="phonenumber"
          ></el-input>
        </el-form-item>
        <el-form-item label="所属企业">
          <el-input
            class="login-input"
            clearable
            disabled
            v-model="companyName"
          ></el-input>
        </el-form-item>
        <el-form-item label="所属部门">
          <el-input
            class="login-input"
            clearable
            disabled
            v-model="deptName"
          ></el-input>
        </el-form-item>
      </el-form>
      <el-col style="text-align: center" :span="24">
        <el-button style="width:90%;" type="primary" @click="regDone">确定</el-button>
      </el-col>
      <el-col :span="24" class="reg-text">
<!--        <router-link :to="{path:'/login'}" style="font-size:12px;">登录</router-link>-->
      </el-col>
    </el-row>
  </div>
</template>

<script>
import count from "@/api/home";
import {userInfoByToken} from "../api/home";

export default {
  name: "Login",
  data() {
    return {
      phonenumber: "",
      password: "",
      companyName: "",
      username: "",
      deptName: "",
      loginName: "",
    };
  },
  computed: {
    styles() {
      return {
        width: this.$store.state.app.device == 'desktop' ? '400px' : `${document.body.clientWidth - 10}px`,
        top: this.$store.state.app.device == 'desktop' ? '20%' : '15%',
        left: this.$store.state.app.device == 'desktop' ? '65%' : '5px',
      }
    }
  },
  mounted() {
    count.userInfoByToken().then((res) => {
      if (res.code === 0) {
        this.username = res.userName;
        this.phonenumber = res.phoneNumber;
        this.companyName = res.tenantName;
        this.deptName = res.deptName;
        this.loginName = res.loginName;
      }
    })
  },
  methods: {
    // 确定
    regDone() {
      const data = {
        userName: this.username,
        loginName: this.loginName
      };
      count.updateUserInfo(data).then((res) => {
        if (res.code === 0) {
          localStorage.setItem("userName", this.username);
          this.$message.success("个人信息修改成功");
          this.$router.push("/");
          this.$router.go(0);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style scoped>

#login {
  /*text-align: center;*/
  font-size: 20px;
  width: 100%;
  height: calc(100vh - 414px);
  min-height: 600px;
  /* background-size: 80% 80%; */
  background: url("../assets/images/register.png");
  background-position: center;
  padding-top: 64px;
}


.login-info {
  position: relative;
  /* left: 23%; */
  /* top: 30%; */
  /* width: 20%; */
  /* margin: 0 auto; */
  background-color: #fff;
  box-shadow: 10px 10px 10px #f2f2f2;
  border-radius: 10px;
  padding: 10px 0;
}

.login-input {
  width: 85%;
  margin-bottom: 0px;
}

.reg-text {
  font-size: 12px !important;
  text-align: right;
  width: 95%;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/UserInfo.vue